import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './Countdown';
import { PricingCards } from './PricingCards';
import { SectionHeading } from './SectionHeading';
import { turboRows } from '../data/salesData';
export function OfferSection() {
  return <section id="oferta" className="border-b border-[var(--violet)]/30 py-16 sm:py-20" data-id="element-135" data-mp="de56r53r0qlb">
      <div className="mx-auto max-w-6xl px-4" data-id="element-136" data-mp="idi2yggifa0k">
        <div className="mx-auto max-w-2xl rounded-2xl border border-[var(--lilac)]/40 bg-[#16102e] p-6 text-center sm:p-8" data-id="element-137" data-mp="icosp5ice2do">
          <p className="mb-5 text-xs font-semibold uppercase tracking-[0.25em] text-[var(--lilac)]" data-id="element-138" data-mp="mgwht3sppkcf">
            ⏰ Precio de lanzamiento — Cierra pronto
          </p>
          <Countdown data-id="element-139" data-mp="wbokgm15ixe2" />
          <p className="mt-6 flex items-center justify-center gap-2 text-sm text-[var(--lilac-light)]" data-id="element-140" data-mp="wawxu0pj89zx">
            <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-141" data-mp="2t7dymr8zo42i" />
            Después sube $10.000 ARS. No vuelve.
          </p>
          <div className="mt-6" data-id="element-142" data-mp="12o1ucztcaw6g">
            <div className="mx-auto h-2 max-w-md overflow-hidden rounded-full bg-white/10" data-id="element-143" data-mp="12oa7mstdk3i6">
              <div className="h-full w-[68%] rounded-full bg-[var(--lilac)]" data-id="element-144" data-mp="xw0aarpxk15v" />
            </div>
            <p className="mt-2 text-sm text-white/60" data-id="element-145" data-mp="syqnljtxe3lq">
              68% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <SectionHeading className="mt-16" data-id="element-146" data-mp="1lm4ccungzsur">Elegí tu plan</SectionHeading>

        <div className="mt-10" data-id="element-147" data-mp="1lka004q9l92a">
          <PricingCards data-id="element-148" data-mp="1gmrt0jvt53wx" />
        </div>

        <div className="mx-auto mt-16 max-w-2xl" data-id="element-149" data-mp="1gnt24it9jgc0">
          <h3 className="text-center font-display text-[28px] font-bold text-[var(--cream)] sm:text-2xl" data-id="element-150" data-mp="1clfzi39tbyjg">
            ¿Qué agrega el Keto Turbo?
          </h3>

          <div className="sales-scrollbar mt-6 overflow-x-scroll pb-3" data-id="element-151" data-mp="17mbnl4vi7mpf">
            <table className="w-[640px] min-w-[640px] border-separate border-spacing-0 overflow-hidden rounded-2xl border border-[var(--violet)]/40 text-left text-sm" data-id="element-152" data-mp="17at73m4ncky">
              <thead data-id="element-153" data-mp="3ttho2q550w5q">
                <tr className="bg-[#16102e]" data-id="element-154" data-mp="3tv154iymbb8k">
                  <th className="p-4 text-center font-semibold text-[var(--cream)]" data-id="element-155" data-mp="3ts6lgtnfhug7">
                    Situación
                  </th>
                  <th className="p-4 font-semibold text-white/45" data-id="element-156" data-mp="3ku2ydswsopma">
                    Sin Keto Turbo
                  </th>
                  <th className="p-4 font-semibold text-[var(--lilac-light)]" data-id="element-157" data-mp="3otlm0wg03est">
                    Con Keto Turbo
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-158" data-mp="3fui1rp53ktcq">
                {turboRows.map((row, i) => <tr key={row.situation} className={i % 2 === 0 ? 'bg-[#0d0819]' : 'bg-[#080510]'} data-id="element-159" data-mp="315bz1r71wl03" data-mpi={i}>
                    <td className="h-[70px] w-[190px] border-t border-white/5 px-[15px] py-4 text-center text-[10px] font-medium text-[var(--cream)]" data-id="element-160" data-mp="364onuhhhg25b">
                      {row.situation}
                    </td>
                    <td className="w-[190px] border-t border-white/5 px-[15px] py-4 text-center text-[10px] text-white/50" data-id="element-161" data-mp="2x5tewxn20dyb">
                      {row.without}
                    </td>
                    <td className="w-[190px] border-t border-white/5 px-[15px] py-4 text-center text-[10px] text-[var(--lilac-light)]" data-id="element-162" data-mp="28kos73wwbbnp">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
}